import React from 'react';
import PropTypes from 'prop-types';
import './PassiveComponent.scss';

export default function PassiveComponent(props) {
  const { name, type, link } = props;

  const imagePath = 'url("/images/passive-components/'+type+'.png")';

  const handleWindowOpen = () => {
    if(link !== null) {
      var windowReference = window.open(link,link,'height=600,width=680');
      windowReference.focus();
    }
  };

  return (
    <div className="passiveComponent" onClick={handleWindowOpen}>
        <div className="imageArea" style={{backgroundImage: imagePath}}></div>
        <div className="label">{name}</div>
    </div>
  );
};

PassiveComponent.propTypes = {
   name: PropTypes.string.isRequired,
   type: PropTypes.string.isRequired,
};
